import { AddPaymentDocument } from './AddPaymentDocument.main';

export { AddPaymentDocument };
